import Reveal from "./Reveal";

export default function SectionHeader({ label, title, subtitle, light }) {
  return (
    <div style={{ textAlign: "center", marginBottom: "clamp(32px, 5vw, 56px)" }}>
      {label && (
        <Reveal>
          <span style={{
            display: "inline-block", fontFamily: "var(--font-body)", fontWeight: 600,
            fontSize: "0.78rem", letterSpacing: "0.14em", textTransform: "uppercase",
            color: light ? "var(--gold-light)" : "var(--gold)",
            marginBottom: "12px",
          }}>
            {label}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 style={{ color: light ? "var(--white)" : "var(--plum)", marginBottom: "14px" }}>{title}</h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p style={{
            color: light ? "rgba(255,255,255,0.65)" : "var(--text-secondary)",
            maxWidth: "580px", margin: "0 auto", fontSize: "1.05rem",
          }}>
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
